module.exports = __webpack_public_path__ + "img/excel.7e70e4af.svg";